// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__1H-Ct","spinner":"Spinner_spinner__3pcmL","spin":"Spinner_spin__3GTc6","icon":"Spinner_icon__1SK_6"};